import Promise from 'bluebird';
import { createActivity } from './instrumentation';

/** Base analyzer
 * all analyzer should implement the functions of
 *  1 analyzeInput
 *  2 getSyntax
 *  3 needEditor
 *  4 getEditor (reactjs object)
 *  5 evaluateRule
 *  6 getCharCountExcludingAdCustomizers
 */
export class AdCustomizerBaseAnalyzer {
  constructor({
    name,
    priority,
    instrumentation,
    i18n,
    activityName,
    scope = {},
    controller,
  }) {
    this.name = name;
    this.instrumentation = instrumentation;
    this.priority = priority;
    this.editor = null;
    this.i18n = i18n;
    this.activityName = activityName;
    this.activity = createActivity(instrumentation, activityName);
    this.scope = scope;
    controller.register(this.priority, this);
  }

  /*
    base response:  {
      itemsToDisplay: {
        name, // Title of the menu item
        description: string, // description line for the menu item
        onClick: func, // menu item's click handler
      }
      type: string,
      // whether the rule matches, if only one rule match then editor might be shown
      match: true/false,
      defaultHandlerForInput: true/false,
    },
    can also add item that has information for inline edit & syntax
  */
  analyzeInput(/* { text, cursorIndex, updateAndCloseCallback, target, adType} */) {
  }

  /* return a reactjs object here */
  getSyntax(/* analyzeResult */) {
  }

  needEditor(/* analyzeResult */) {
  }

  getEditor(/* {target, container, analyzeResult, key, updateAction,remainingCountCallBack} */) {
  }

  // return a promise of evaluted text
  evaluateRule(/* {text, adType} */) {
  }

  /**
   * Should return `true` if the analyzer considers that the click happened outside the
   * controller boundaries.
   * @param {Object} event the click event.
   * @returns {Boolean} `true` if clicked outside the analyzer managed area.
   * Otherwise, `false`. The default return value is `true`.
   */
  isClickedAway(/* event */) {
    return true;
  }

  // evaluate rules and update text for the evaluated values, do not override this
  evaluateText(text, adType) {
    if (!text) {
      return Promise.resolve(text);
    }

    const pipeNextEvaluator = (previewPromise, previousResult, resolve) => {
      previewPromise.then((result) => {
        if (!result) {
          resolve(text);
        }
        // evaluate till no new rules found, in case there are multiple rules in text
        if (result === previousResult) {
          resolve(result);
        } else {
          pipeNextEvaluator(this.evaluateRule(result, adType), result, resolve);
        }
      });
    };

    return new Promise((resolve) => {
      pipeNextEvaluator(this.evaluateRule(text, adType), text, resolve);
    });
  }

  /* get chart count excluding adcustomizers rules{
      processedText: text,
      charCount: 0,
    } */
  getCharCountExcludingAdCustomizers(text) {
    return {
      processedText: text,
      charCount: 0,
    };
  }

  traceUpdate(oldValue, newValue, customizerName, adType) {
    this.activity.trace(
      `${adType} targetUpdateFromAdCustomizer ${customizerName}`,
      `updating field value from ${oldValue} to ${newValue}`
    );
  }
}
